export default __webpack_public_path__ + "pypi/streamlit-1.39.0-cp312-none-any.whl";